import reducers from "./EkgListTableReducers";

export default reducers;
